import { render, staticRenderFns } from "./fiserv-summary.vue?vue&type=template&id=81e17450&scoped=true"
import script from "./fiserv-summary.vue?vue&type=script&lang=js"
export * from "./fiserv-summary.vue?vue&type=script&lang=js"
import style0 from "./fiserv-summary.vue?vue&type=style&index=0&id=81e17450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e17450",
  null
  
)

export default component.exports